export enum ImageListTab {
    Unedited = 'unedited',
    Edited = 'edited'
}

type GetInitialTabArgs = {
    showUneditedImages: boolean;
    editedImageCount: number;
    photographerIsEditor: boolean;
};

export function getInitialTab({
    showUneditedImages,
    editedImageCount,
    photographerIsEditor
}: GetInitialTabArgs): ImageListTab {
    if (!showUneditedImages || editedImageCount > 0 || photographerIsEditor) {
        return ImageListTab.Edited;
    }

    return ImageListTab.Unedited;
}
